import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  const painPoints = [{
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="w-8 h-8" data-id="element-99">
          <circle cx="12" cy="12" r="10" data-id="element-100"></circle>
          <polyline points="12 6 12 12 16 14" data-id="element-101"></polyline>
        </svg>,
    text: 'Editar un solo video de alta retención te toma 20 horas de frustración.'
  }, {
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="w-8 h-8" data-id="element-102">
          <line x1="12" y1="1" x2="12" y2="23" data-id="element-103"></line>
          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" data-id="element-104"></path>
        </svg>,
    text: 'Te cuesta $500 con una agencia que no entiende tu mensaje.'
  }, {
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="w-8 h-8" data-id="element-105">
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" data-id="element-106"></path>
          <circle cx="12" cy="12" r="3" data-id="element-107"></circle>
        </svg>,
    text: 'Ves a otros con la mitad de tu conocimiento llevándose toda la atención.'
  }];
  return <section className="py-12 md:py-24 px-4 md:px-6 bg-navy-900" data-id="element-108">
      <div className="max-w-4xl mx-auto" data-id="element-109">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8 md:mb-16" data-id="element-110">
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-4 md:mb-6" data-id="element-111">
            El experto moderno está atrapado en una trampa mortal.
          </h2>
          <p className="text-base md:text-lg text-gray-300 font-light max-w-2xl mx-auto" data-id="element-112">
            Por un lado, sabes que necesitas contenido de alta calidad para que
            te respeten como autoridad. Por otro lado, la realidad te golpea.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-4 md:gap-8 mb-8 md:mb-16" data-id="element-113">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-navy-800 p-5 md:p-8 rounded-xl border border-white/5 flex flex-col items-center text-center" data-id="element-114">
              <div className="text-gold-500 mb-4 md:mb-6 p-3 md:p-4 bg-navy-900 rounded-full border border-gold-500/20" data-id="element-115">
                {point.icon}
              </div>
              <p className="text-gray-300 font-light text-sm md:text-base" data-id="element-116">
                {point.text}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="space-y-4 md:space-y-6 text-base md:text-lg text-gray-300 font-light leading-relaxed bg-navy-800/50 p-5 md:p-10 rounded-2xl border border-white/5" data-id="element-117">
          <p data-id="element-118">
            El costo de no profesionalizar tu imagen visual ya no es solo ego;
            es el costo de oportunidad de los clientes que nunca te contactarán
            porque no pareces un referente.
          </p>
          <p data-id="element-119">
            La mayoría intenta solucionar esto con "packs de prompts" baratos de
            $5 que generan resultados mediocres, robóticos y que gritan "IA
            barata" a leguas. Eso no es autoridad, eso es ruido.
          </p>
          <p className="text-white font-medium" data-id="element-120">
            Para dominar en 2026, necesitas un sistema que combine la psicología
            del storytelling visual con el poder de la IA, sin que tú tengas que
            convertirte en un editor profesional.
          </p>
        </motion.div>
      </div>
    </section>;
}